// extracted by mini-css-extract-plugin
module.exports = {"ctn":"UserDetails_ctn__zdDCV","divImg":"UserDetails_divImg__MTdJZ","img":"UserDetails_img__3Pa_i","divInfo":"UserDetails_divInfo__3WicS"};